import { Dialog } from '@/components/UI/Dialog'
import { HtmlContent } from '@/components/UI/HtmlContent'
import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  description: string
  isOpen: boolean
  onClose: () => void
}

/** キャンペーン概要ダイアログ */
export const DialogCampaignDescription = memo(({ description, isOpen, onClose }: Props) => {
  const { t } = useTranslation()

  return (
    <Dialog selectorState={isOpen} closeFunc={onClose} title={t('home.summary', '概要')}>
      {/*
        description は管理画面の WYSIWYG（TinyMCE）が出力した HTML（#3609）。
        改行は <br> / 段落で表現されるため、whitespace-pre-wrap は付けない。
        付けると TinyMCE がブロック間に入れる改行や連続空白がそのまま表示され、エディタの見た目と食い違う
      */}
      <HtmlContent html={description} variant="body1" className="mt-4 text-gray-700" />
    </Dialog>
  )
})
